<ng-container class="cursor-pointer text-primary underline"> v{{ applicationVersion }} </ng-container>
